import { connect } from 'react-redux';
import * as eventActions from '../../Actions/EventActions';
import { getFreeSlotsByDate, getEventsById } from '../../Reducers/EventReducer';
import { getApiStatus } from '../../Reducers/ApiStatusReducer';
import AvailabilityCalendar from '../../Components/AvailabilityCalendar/AvailabilityCalendar';

const mapStateToProps = (state) => ({
  freeSlots: getFreeSlotsByDate(state),
  eventsById: getEventsById(state),
  freeSlotsApiStatus: getApiStatus(state, 'GetFreeSlots'),
});

const mapDispatchToProps = {
  fetchFreeSlots: eventActions.fetchFreeSlots,
  updateEventById: eventActions.updateEventById,
};

export default connect(mapStateToProps, mapDispatchToProps)(AvailabilityCalendar);
